<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Keyword (always visible) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">School Name (optional)</h2>
    <div class="filter-list__group-content">
      <input id="flightSchoolName" type="text" class="landing-page__field landing-page__query-field"
             [(ngModel)]="flightSchoolFinderFilter.name" (input)="onNameChange()"
             aria-label="School Name" autocomplete="off" autocorrect="off"
             [attr.aria-invalid]="nameTooShort ? true : null"
             [attr.aria-describedby]="nameTooShort ? 'flightSchoolNameError' : null">
      <div *ngIf="nameTooShort" id="flightSchoolNameError" class="flight-school-filter__validation-message" role="alert">
        Please enter at least three characters to search by school name.
      </div>
    </div>
  </div>
</div>

<!-- Selected-filter chips: the first few active filters (click a chip to remove it) plus a "+N more" marker,
     so selections stay visible even when every section is collapsed. -->
<div class="filter-list flight-school-filter__chips-wrapper" *ngIf="visibleChips.length > 0">
  <div class="flight-school-filter__chips">
    <button class="flight-school-filter__chip" *ngFor="let chip of visibleChips; trackBy: trackByChip"
            type="button" [title]="chip.label" [attr.aria-label]="'Remove ' + chip.label"
            (click)="onToggleFacet(chip.group, chip.value, false)">
      <span class="flight-school-filter__chip-label">{{ chip.label }}</span>
      <mat-icon class="flight-school-filter__chip-remove">close</mat-icon>
    </button>
    <span class="flight-school-filter__chip-more" *ngIf="overflowCount > 0">+{{ overflowCount }} more</span>
  </div>
</div>

<!-- Collapsible facet sections. There are far more Flight School facets than fit on one screen, so each is
     collapsible and its header shows a badge with the number of selected filters. -->
<div class="filter-list flight-school-filter__sections">
  <div class="filter-list__group" *ngFor="let section of sections">
    <button type="button" class="flight-school-filter__section-header"
            [class.flight-school-filter__section-header--open]="expanded[section.key]"
            [attr.aria-expanded]="expanded[section.key]"
            (click)="toggleSection(section.key)">
      <span class="flight-school-filter__section-title">{{ section.title }}</span>
      <span class="flight-school-filter__section-badge" *ngIf="selectedCount(section.key) > 0">{{ selectedCount(section.key) }}</span>
      <mat-icon class="flight-school-filter__section-chevron">{{ expanded[section.key] ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="flight-school-filter__section-body" *ngIf="expanded[section.key]">
      <div class="filter-list__group-buttonbar">
        <span class="filter-list__group-button" (click)="onSelectAll(section.key, section.options)">Select All</span> |
        <span class="filter-list__group-button" (click)="onClearAll(section.key)">Clear All</span>
      </div>
      <div class="filter-list__group-content flight-school-filter__section-options">
        <div class="filter" *ngFor="let option of section.options">
          <mat-checkbox [checked]="isFacetSelected(section.key, option.value)"
                        (change)="onToggleFacet(section.key, option.value, $event.checked)"
                        [attr.aria-label]="option.label" class="filter__checkbox">
            <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
